import {computed, observable, action} from 'mobx';
import get from 'lodash/get';
import {ClientRoomStorage} from '../_contracts/ClientRoomStorage';

interface IDashboardState {
    accountData: any;
    clientRoomStorage: ClientRoomStorage;
    videoModeState: {videoState: {isVideoStreamPlaying: boolean}};
}

export interface ICameraZoomController {
    displayCameraZoomControl: boolean;
    cameraZoomDisabled: boolean;
    isZoomPending: boolean;
    requestZoom(chatApi: {requestAction(type: string, data?: unknown): void} | null | undefined, level: number): void;
    clearPendingZoom(): void;
}

export class CameraZoomController implements ICameraZoomController {
    @observable private _pendingZoom: boolean = false;
    private _pendingZoomTimeout: ReturnType<typeof setTimeout> | null = null;

    constructor(private readonly _ds: IDashboardState) {}

    @computed
    get displayCameraZoomControl(): boolean {
        return (
            !!get(this._ds.accountData, 'protectedSettings.enableRemoteCameraZoom') &&
            this._ds.clientRoomStorage.zoomCapability !== null &&
            this._ds.clientRoomStorage.zoomCapability !== undefined &&
            this._ds.videoModeState.videoState.isVideoStreamPlaying
        );
    }

    @computed
    get cameraZoomDisabled(): boolean {
        return !this._ds.clientRoomStorage.zoomCapability?.supported;
    }

    @computed
    get isZoomPending(): boolean {
        return this._pendingZoom;
    }

    @action
    requestZoom(chatApi: {requestAction(type: string, data?: unknown): void} | null | undefined, level: number): void {
        if (this._pendingZoom || !chatApi) return;
        this._pendingZoom = true;
        chatApi.requestAction('setZoomLevel', level);
        this._pendingZoomTimeout = setTimeout(() => {
            this.clearPendingZoom();
        }, 3000);
    }

    @action
    clearPendingZoom(): void {
        this._pendingZoom = false;
        if (this._pendingZoomTimeout !== null) {
            clearTimeout(this._pendingZoomTimeout);
            this._pendingZoomTimeout = null;
        }
    }
}
